import HistoricNarConfigFilters from "./components/historicNarConfigFilters";
import HistoricNarConfigModalHost from "./components/historicNarConfigModalHost";
import HistoricNarConfigResultsPanel from "./components/historicNarConfigResultsPanel";
import "./historicNarConfigLayout.scss";
import useHistoricNarConfigLayout from "./hooks/useHistoricNarConfigLayout";

/** Historic NAR page shell and composition. */
const HistoricNarConfigLayout = () => {
  const { tableRef, filters, results, modal } = useHistoricNarConfigLayout();
  return (
    <div className="historic-nar-config--main-container flex h-screen max-h-screen flex-col overflow-hidden">
      <div className="historic-nar-config__header mb-2 flex items-end justify-between text-h11 font-bold text-primaryGray-1">
        Historic NAR Config
      </div>
      <div className="historic-nar-config__content flex w-full flex-1 flex-col overflow-hidden">
        <div className="historic-nar-config__table-container flex flex-1 flex-col overflow-hidden px-4 pb-4">
          <HistoricNarConfigFilters
            payer={filters.payer}
            payerOptions={filters.payerOptions}
            onPayerChange={filters.onPayerChange}
            lineOfBusiness={filters.lineOfBusiness}
            onLineOfBusinessChange={filters.onLineOfBusinessChange}
          />
          <HistoricNarConfigResultsPanel
            tableRef={tableRef}
            {...results}
            onSearchTextChange={filters.onSearchTextChange}
          />
        </div>
      </div>
      <HistoricNarConfigModalHost {...modal} />
    </div>
  );
};

export default HistoricNarConfigLayout;
